module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('el-row', {
    staticStyle: {
      "padding": "10px 0px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('order-form', {
    attrs: {
      "form": _vm.form,
      "fileList": _vm.fileList
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit(_vm.form)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.save')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'order.view'
      }
    }
  }, [_c('el-button', [_vm._v(_vm._s(_vm.$t('base.cancel')))])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45280620"}!./src/pages/order/edit/index.html
// module id = 809
// module chunks = 1